import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leistungsart'
})
export class LeistungsartPipe implements PipeTransform {

  constructor() {
}
  leistungsartOptions = [
    { id: 1, value: 'PRUEF', bezeichnung: 'Prüfung' },
    { id: 2, value: 'BEHAUSL', bezeichnung: 'Behälterauslieferung' },
    { id: 3, value: 'BEHRUECK', bezeichnung: 'Behälterrückholung' },
    { id: 4, value: 'BEHUML', bezeichnung: 'Behälterumlagerung' },
  ];

  transform(value: unknown, ...args: unknown[]): unknown {
    return this.leistungsartOptions.find(f => f.value == value)?.bezeichnung;
  }

}
